<template lang='pug'>
.title-filter.text--bold.show--bigScreens
  .title-buttonFilter.all(v-if="displayFilter" @click="filter('all')") 不限
  .title-buttonFilter.today(v-if="displayFilter" @click="filter('today')") 今日
  .title-buttonFilter.this-week(v-if="displayFilter" @click="filter('this-week')") 本週
  .title-buttonFilter.this-month(v-if="displayFilter" @click="filter('this-month')") 本月
  .title-dropdownFilter.other-date(id="date-picker-dropdownFilter" v-if="displayFilter" @click="clickDatePicker")
    span.choose-date(ref='dateButton') 其它時段
    i.title-iconFilter.icon-caret-down
  DatePicker(
    :startDate='startDate' 
    @filter="filterWithRange"
    :date1='start ? start.toLocaleDateString() : ""'
    :date2='end ? end.toLocaleDateString() : ""'
    ref='datePicker' header)
  .title-gridFilter.show--bigScreens(v-if="displayLayoutOption")
    .title-iconLayoutFilter
  .title-iconLayoutFilter(v-if="displayLayoutOption")
    div.title-iconGrid-or-List(:class='listMode== true ? "title-iconList" : "title-iconGrid"' @click="changeViewMode")
</template>

<script>
import DatePicker from '@/components/modules/date_picker/date_picker.vue'
import $ from 'jquery'
import { getFilterRange } from '@/plugins/tool.js'
import { setGtag } from '@/plugins/gtag.js'

export default {
  props: {
    displayFilter: Boolean,
    displayLayoutOption: Boolean,
    displayAddButton: Boolean,
    type: String,
    filterType: String,
    listMode: Boolean
  },
  components: {
    DatePicker
  },
  data() {
    let queryParams = this.$route.query.params
    let start, end = null
    if (queryParams) {
      queryParams = JSON.parse(queryParams)
      if (queryParams.startDate && queryParams.endDate) {
        start = new Date(queryParams.startDate)
        end = new Date(queryParams.endDate)
      }
    }
    return {
      typeList: ["today", "this-week", "this-month", "other-date"],
      startDate: this.$store.state.datePickerConfig.start,
      start: start,
      end: end
    }
  },
  mounted() {
    this.changeBtnColor(this.filterType)
  },
  methods: {
    filter(type) {
      setGtag('click', '已查核', 'filter', type, this.$route.query.type !== 'verified')
      this.$emit('changeType', type)
      if (type === 'all') {
        this.$emit('filter', type)
      } else {
        var days = getFilterRange(type)
        this.$emit('filter', days[0], days[1])
      }
    },
    filterWithRange(start, end) {
      setGtag('click', '已查核', 'filter', 'datePicker', this.$route.query.type !== 'verified')
      this.$emit('changeType', "other-date")
      this.$emit('filter', start, end)
    },
    async changeBtnColor(type) {
      let otherDateIcon = ".other-date .title-iconFilter"
      $("." + type).addClass("title-buttonFilter--active")
      if (type == 'other-date') {
        $(otherDateIcon).removeClass("icon-caret-down")
        $(otherDateIcon).addClass("icon-caret-down--active")
      }
    },
    clickDatePicker() {
      this.$refs.datePicker.focus()
    },
    changeViewMode() {
      setGtag('click', '已查核', 'layout', this.listMode? 'list' : 'grid', this.$route.query.type !== 'verified')
      this.$emit("changeViewMode", !this.listMode)
    },
  }
}
</script>
